var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat"},[_c('h5',{staticClass:"num left black",staticStyle:{"font-weight":"700"}},[_vm._v(_vm._s(_vm.stat))]),_c('p',{staticClass:"title sss left",staticStyle:{"margin":"0px"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }